import { useQueryClient } from "@tanstack/react-query";
import { keys } from "../../api/queries";

/** Refetch what a change to a menu (or to the menu list) can affect. Await it before showing the result. */
export function useRefreshMenus(rid: string) {
  const qc = useQueryClient();
  return (mid?: string) =>
    Promise.all([
      qc.invalidateQueries({ queryKey: keys.menus(rid) }),
      ...(mid
        ? [
            qc.invalidateQueries({ queryKey: keys.draft(rid, mid) }),
            qc.invalidateQueries({ queryKey: keys.preview(rid, mid) }),
            qc.invalidateQueries({ queryKey: keys.published(rid, mid) }),
          ]
        : []),
    ]);
}
